import { useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const Field = ({ label, children, hint, className = "" }) => (
  <div className={className}>
    <label className="field-label">{label}</label>
    {children}
    {hint && <p className="mt-1.5 text-xs text-warm-text">{hint}</p>}
  </div>
);

export const TextInput = (props) => <Input {...props} className={`bg-ivory-deep border-white/10 rounded-xl h-12 text-white transition-[border-color,box-shadow] duration-300 focus-visible:ring-0 focus-visible:border-gold focus-visible:shadow-[0_0_0_3px_rgba(212,175,55,0.15)] ${props.className || ""}`} />;

export function SpecialistsEditor({ value, onChange, testid = "specialists" }) {
  const update = (i, k, v) => onChange(value.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  return (
    <div data-testid={`${testid}-editor`} className="space-y-3">
      {value.map((s, i) => (
        <div key={s.id || i} className="flex gap-2 items-center">
          <TextInput data-testid={`${testid}-first-name-${i}`} placeholder="Nome" value={s.first_name} onChange={(e) => update(i, "first_name", e.target.value)} />
          <TextInput data-testid={`${testid}-last-name-${i}`} placeholder="Cognome" value={s.last_name} onChange={(e) => update(i, "last_name", e.target.value)} />
          <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))}
            className="h-12 w-12 shrink-0 rounded-xl flex items-center justify-center border border-white/10 hover:border-gold hover:text-gold transition-colors" aria-label="Rimuovi">
            <X className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </div>
      ))}
      <button type="button" data-testid={`${testid}-add-btn`} onClick={() => onChange([...value, { first_name: "", last_name: "" }])}
        className="btn-link inline-flex items-center gap-1.5">
        <Plus className="w-3.5 h-3.5" /> Aggiungi specialist
      </button>
    </div>
  );
}

export function PasswordChangeCard() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (form.new_password !== form.confirm) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password aggiornata");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <form onSubmit={submit} className="lux-card p-6 sm:p-8 space-y-5" data-testid="password-change-form">
      <h2 className="text-2xl font-normal">Cambia password</h2>
      <Field label="Password attuale"><TextInput data-testid="current-password-input" type="password" value={form.current_password} onChange={set("current_password")} required /></Field>
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Nuova password"><TextInput data-testid="new-password-input" type="password" value={form.new_password} onChange={set("new_password")} required /></Field>
        <Field label="Ripeti la nuova password"><TextInput data-testid="confirm-password-input" type="password" value={form.confirm} onChange={set("confirm")} required /></Field>
      </div>
      <button data-testid="password-change-submit" disabled={busy} className="btn-ghost">{busy ? "Salvataggio…" : "Aggiorna password"}</button>
    </form>
  );
}
